if (!customElements.get('moda-clubs-watch-sign')) {
  customElements.define('moda-clubs-watch-sign', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.events = new AbortController();
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.manualPause = false;
      this.visible = false;
      this.pausedAnimations = new Set();
      this.pauseButton = this.querySelector('[data-sign-pause]');
      this.controls = this.querySelector('.mc-watch-controls');
      const signal = this.events.signal;
      this.querySelector('[data-sign-replay]').addEventListener('click', () => {
        this.manualPause = false;
        this.pausedAnimations.clear();
        this.getAnimations({ subtree: true }).forEach(animation => {
          animation.currentTime = 0;
          animation.play();
        });
        this.updatePlayback();
      }, { signal });
      this.pauseButton.addEventListener('click', () => {
        this.manualPause = !this.manualPause;
        this.updatePlayback();
      }, { signal });
      this.reduced.addEventListener('change', () => this.configure(), { signal });
      document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal });
      if ('IntersectionObserver' in window) {
        this.visibility = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.15;
          this.updatePlayback();
        }, { threshold: 0.15 });
        this.visibility.observe(this);
      } else this.visible = true;
      this.configure();
    }

    configure() {
      const allowed = this.dataset.motion === 'true' && !this.reduced.matches && typeof this.getAnimations === 'function';
      this.classList.toggle('mc-watch-active', allowed);
      this.dataset.state = allowed ? 'ready' : 'static';
      this.controls.hidden = !allowed;
      this.pausedAnimations.clear();
      this.updatePlayback();
    }

    updatePlayback() {
      if (!this.events || this.dataset.state !== 'ready') return;
      const paused = this.manualPause || !this.visible || document.hidden;
      const animations = this.getAnimations({ subtree: true });
      if (paused) {
        animations.forEach(animation => {
          if (animation.playState === 'running' || animation.pending) {
            animation.pause();
            this.pausedAnimations.add(animation);
          }
        });
      } else {
        this.pausedAnimations.forEach(animation => {
          const end = animation.effect?.getComputedTiming().endTime ?? Infinity;
          if (animation.currentTime < end) animation.play();
        });
        this.pausedAnimations.clear();
      }
      this.dataset.running = String(!paused);
      this.dataset.paused = String(this.manualPause);
      this.pauseButton.textContent = this.manualPause ? this.dataset.resume : this.dataset.pause;
      this.pauseButton.setAttribute('aria-pressed', String(this.manualPause));
    }

    disconnectedCallback() {
      this.events?.abort();
      this.visibility?.disconnect();
      if(typeof this.getAnimations === 'function')this.getAnimations({ subtree: true }).forEach(animation => animation.cancel());
      this.classList.remove('mc-watch-active');
      this.pausedAnimations?.clear();
      this.events = null;
    }
  });
}
